import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Envoie un event `page_view` à Google Analytics 4 à chaque changement de route
 * (SPA React Router). Le config initial dans index.html a désactivé le
 * page_view automatique — cette vue englobe donc le premier chargement.
 */
export default function PageTracker() {
  const location = useLocation();

  useEffect(() => {
    if (typeof window === "undefined" || typeof window.gtag !== "function") return;
    window.gtag("event", "page_view", {
      page_path: location.pathname + location.search,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [location]);

  return null;
}
